import type { Ref } from 'vue';

import { pushGA4EcommerceEvent } from '@/utils/gtmEcommerce';

export function useFavorites() {
  async function handleAddCrossSellingToFavorite(event: Event, isFavorite: Ref<boolean>) {
    event.preventDefault(); // disable onClick card navigation
    const woodyCart = document.querySelector('.woody-favorites-cart');
    if (!woodyCart) {
      console.warn('No host favorites-cart detected.');
      return;
    }

    const targetElement = event.target as HTMLElement;
    const target = targetElement.closest('#card_favorite') as HTMLElement;
    // TODO: ADD dataset-id on root tag and check dataset.id read
    const id = target?.dataset.id;

    if (!id) {
      console.warn('No id detected for the selected activity.');
      return;
    }

    let postId;
    try {
      const url = `${window.location.origin}/wp-json/woody/youbook/product_id?id=${id}&lang=fr`;
      const response = await fetch(url);
      postId = await response.json();
    }
    catch (err) {
      console.warn('Unable to get favorites-cart identifier', err);
      return;
    }

    const favorites = window.localStorage.getItem('woody_favorites');
    const newFavorite = { [postId]: 'f' };
    const payload = favorites ? JSON.parse(favorites) : {};

    let newPayload;
    const isAlreadyFavorite = Object.keys(payload).includes(postId.toString());
    if (isAlreadyFavorite) {
      delete payload[postId];
      newPayload = { ...payload };
      isFavorite.value = false;
    }
    else {
      newPayload = { ...payload, ...newFavorite };
      isFavorite.value = true;

      pushGA4EcommerceEvent('add_to_wishlist', {
        items: [{ item_id: id, item_name: '', price: 0, quantity: 1, currency: 'EUR' }],
      });
    }

    window.localStorage.setItem('woody_favorites', JSON.stringify(newPayload));
    const updateFavs = new Event('update', { bubbles: true, cancelable: false, composed: true });
    woodyCart.dispatchEvent(updateFavs);
  }

  return {
    handleAddCrossSellingToFavorite,
  };
}
